var map = {
	"./activedirectory.svg": 78315,
	"./adfs.svg": 95522,
	"./azuread.svg": 59542,
	"./custom.svg": 10161,
	"./email.svg": 99008,
	"./freeipa.svg": 46526,
	"./github.svg": 92165,
	"./googleoauth.svg": 3282,
	"./grafana.svg": 10928,
	"./jaeger.svg": 80258,
	"./keycloak.svg": 72775,
	"./kiali.svg": 3756,
	"./linux.svg": 51386,
	"./longhorn.svg": 38713,
	"./neuvector.svg": 53229,
	"./okta.svg": 49483,
	"./openid.svg": 48119,
	"./openldap.svg": 28947,
	"./pagerduty.svg": 61533,
	"./ping.svg": 19536,
	"./prometheus.svg": 87968,
	"./shibboleth.svg": 65560,
	"./slack.svg": 41560,
	"./webhook.svg": 92115,
	"./windows.svg": 44335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17050;